import {
  Circle4,
  Timer4Background,
  Timer4Body,
  Timer4Center,
  Timer4Header,
  Timer4LeftItemWrapper,
  Timer4LeftWrapper,
  Timer4NextBlindWrapper,
  Timer4Notice,
  Timer4NowBlindWrapper,
  Timer4PrizeItem,
  Timer4PrizeItemTop3,
  Timer4RightWrapper,
  Timer4Wrapper,
} from "./styles";
import { formatNumber } from "../../../utils/timer";
import { useRef } from "react";
import TimerPrizeBox from "../component/timer-prize-box";
import AdVideo from "../../../component/AdVideo";
import { useCapture } from "../../../hooks/use-capture";
import { CaptureButton } from "../../../component/CaptureButton";
import { useCopyTournamentText } from "../../../hooks/use-copy-tournament-text";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";

const UserTimer4 = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleCapture } = useCapture();
  const { copyTournamentText } = useCopyTournamentText();
  const radius = 491;
  const circumference = 2 * Math.PI * radius;

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <Timer4Wrapper ref={containerRef}>
        {backgroundImage && (
          <Timer4Background backgroundImage={backgroundImage} />
        )}
        <Timer4Header>
          <div className="tournament-info-row">
            {coverImage && <img src={coverImage} alt="logo" />}
            <div className="title">{data?.title}</div>
            <div className="type">
              <span>{data?.subTitle}</span>
            </div>
          </div>
          <div className="pub-name">{pub?.cafeName}</div>
        </Timer4Header>
        <Timer4Center>
          <div className="now-level">{`${
            data?.timerDto &&
            timeInfo?.elapsedTimeMs &&
            timeInfo?.elapsedTimeMs > 0
              ? timeInfo.currentLevel?.type === "LEVEL"
                ? "현재 " + timeInfo.currentLevel.level + "LV"
                : "BREAK"
              : "시작 준비중"
          }`}</div>
          <div
            className={`time ${
              timeInfo.currentLevel?.type === "LEVEL" &&
              timeInfo?.elapsedTimeMs &&
              timeInfo?.elapsedTimeMs > 0
                ? ""
                : "break"
            }`}
          >
            {timeInfo.remainingTimeInCurrentLevel}
          </div>
          <img
            className="logo"
            src={`/image-web/timer/timer4-${
              timeInfo.currentLevel?.type === "LEVEL" ? "" : "red-"
            }logo.svg`}
            alt="logo"
          />
          <div className="timer-wrapper">
            <Circle4>
              <defs>
                <linearGradient
                  id="progress-gradient"
                  x1="100%"
                  y1="0%"
                  x2="0%"
                  y2="0%"
                >
                  <stop
                    offset="0%"
                    stop-color="rgb(0, 20, 44)"
                    stop-opacity="0.7"
                  />
                  <stop offset="10%" stop-color="rgba(0, 20, 44, 0.5)" />
                  <stop offset="100%" stop-color="rgba(255, 255, 255, 1)" />
                </linearGradient>
                <linearGradient
                  id="progress-gradient-red"
                  x1="100%"
                  y1="0%"
                  x2="0%"
                  y2="0%"
                >
                  <stop
                    offset="0%"
                    stop-color="rgb(0, 20, 44)"
                    stop-opacity="0.7"
                  />
                  <stop offset="10%" stop-color="rgba(0, 20, 44, 0.5)" />
                  <stop offset="100%" stop-color="rgba(255, 104, 104, 1)" />
                </linearGradient>
                <linearGradient
                  id="back-gradient"
                  x1="100%"
                  y1="0%"
                  x2="0%"
                  y2="0%"
                >
                  <stop offset="0%" stop-color="rgba(240, 240, 240, 0.20)" />
                  <stop offset="100%" stop-color="rgba(0, 0, 0, 0.20)" />
                </linearGradient>
              </defs>

              <circle
                className="background"
                stroke="url(#back-gradient)"
                r={468}
                cx="482"
                cy="482"
              />
              <circle
                className="progress"
                r={468}
                cx="482"
                cy="482"
                stroke={`url(#progress-gradient${
                  timeInfo.currentLevel?.type === "LEVEL" ? "" : "-red"
                })`}
                strokeDasharray={circumference}
                strokeDashoffset={
                  timeInfo.currentLevel &&
                  timeInfo.remainingTimeInCurrentLevelMs &&
                  timeInfo.elapsedTimeMs &&
                  timeInfo.elapsedTimeMs > 0
                    ? circumference -
                      (timeInfo.remainingTimeInCurrentLevelMs /
                        (timeInfo.currentLevel?.time * 60000)) *
                        circumference
                    : 0
                }
              />
            </Circle4>

            <img
              src={
                timeInfo.currentLevel?.type === "LEVEL"
                  ? "/image-web/timer/timer4-circle.png"
                  : "/image-web/timer/timer4-circle-red.png"
              }
              alt="타이머"
            />
          </div>
          <Timer4NowBlindWrapper>
            <div className="title">NOW BLINDS</div>
            <div className="value">{getNowBlind()}</div>
          </Timer4NowBlindWrapper>
          <Timer4NextBlindWrapper>
            <div className="title">NEXT BLINDS</div>
            <div className="value">{getNextBlind()}</div>
          </Timer4NextBlindWrapper>
        </Timer4Center>
        <Timer4Body>
          <Timer4LeftWrapper>
            <Timer4LeftItemWrapper isRed={false}>
              <div className="title">PLAYERS</div>
              <div className="value">{`${userCount} / ${
                adOnUserCount + reBuyInUserCount + entryUserCount
              }`}</div>
            </Timer4LeftItemWrapper>
            <Timer4LeftItemWrapper isRed={false}>
              <div className="title">TOTAL TIME</div>
              <div className="value">{timeInfo.elapsedTime}</div>
            </Timer4LeftItemWrapper>
            <Timer4LeftItemWrapper isRed={false}>
              <div className="title">TOTAL STACKS</div>
              <div className="value">{formatNumber(stack)}</div>
            </Timer4LeftItemWrapper>
            <Timer4LeftItemWrapper isRed={false}>
              <div className="title">AVG STACKS</div>
              <div className="value">{formatNumber(avgStack)}</div>
            </Timer4LeftItemWrapper>
            <Timer4LeftItemWrapper isRed={true}>
              <div className="title">NEXT BREAK</div>
              <div className="value">{timeInfo.timeUntilNextBreak}</div>
            </Timer4LeftItemWrapper>
          </Timer4LeftWrapper>
          <Timer4RightWrapper>
            <div className="prize-wrapper">
              <div className="title">PRIZE POOL</div>
              {data?.moneyInChip.map((item: any, index: number) =>
                index < 3 ? (
                  <Timer4PrizeItemTop3 subPrizeFont={subPrizeFont}>
                    <div className={`rank`}>{`${index + 1}${
                      index === 0
                        ? "st"
                        : index === 1
                          ? "nd"
                          : index === 2
                            ? "rd"
                            : "th"
                    }`}</div>
                    <TimerPrizeBox data={data} item={item} index={index} />
                  </Timer4PrizeItemTop3>
                ) : (
                  visibleRanks.includes(index + 1) && (
                    <Timer4PrizeItem
                      length={data?.moneyInChip.length}
                      subPrizeFont={subPrizeFont}
                    >
                      <div className={`rank`}>{`${index + 1}${
                        index === 0
                          ? "st"
                          : index === 1
                            ? "nd"
                            : index === 2
                              ? "rd"
                              : "th"
                      }`}</div>
                      <TimerPrizeBox data={data} item={item} index={index} />
                    </Timer4PrizeItem>
                  )
                ),
              )}
            </div>
            <Timer4Notice
              dangerouslySetInnerHTML={{
                __html: data?.notice
                  ? data.notice.replace(/\n/g, "<br />")
                  : "",
              }}
            />
          </Timer4RightWrapper>
        </Timer4Body>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </Timer4Wrapper>
      <CaptureButton
        onCapture={() => handleCapture(containerRef.current)}
        onCopyText={() => copyTournamentText(data, timeInfo)}
      />
    </>
  );
};
export default UserTimer4;
